import '@styles/main.css'
import '@splidejs/splide/css';

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'
import clickOutside from './utils/click-outside';

import * as Sentry from "@sentry/vue";

const app = createApp(App)
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate)

if (import.meta.env.MODE !== 'development') {
  console.log('production');

  Sentry.init({
    app,
    dsn: "https://f0026d741f96ea2bab2b9b61de7ec36a@o4508658453905408.ingest.de.sentry.io/4508658557911120",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration({
        networkDetailAllowUrls: [ // Allow staging.wyrld.de to capture additional headers
          /^https:\/\/staging\.wyrld\.de/,
          /^https:\/\/dev\.wyrld\.de/,
          /^https:\/\/assets-staging\.wyrld\.de.*/,
          /^https:\/\/assets-dev\.wyrld\.de.*/,
        ],
        networkResponseHeaders: ['Cf-Cache-Status', 'Cf-Ray'], // Add additional response headers in the replay
      }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/dev\.wyrld\.de/, /^https:\/\/staging\.wyrld\.de/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Profiling
    profilesSampleRate: 1.0, // Profile 100% of the transactions. This value is relative to tracesSampleRate
  });
}

app.use(pinia)
app.use(router)

app.directive('click-outside', clickOutside);

app.mount('#app')
